<template>
  <nav
    class="t-navigation"
    :class="[
      { 't-navigation--expanded': expanded },
    ]"
  >
    <div class="t-navigation__branding" v-if="$slots.branding">
      <slot name="branding"></slot>
    </div>

    <div class="t-navigation__body">
      <ul class="t-navigation__items">
        <slot></slot>
      </ul>

      <div class="t-navigation__drawer" v-if="$slots.drawer">
        <div class="t-navigation__drawer-content">
          <slot name="drawer"></slot>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 't-navigation',

  props: {
    expanded: Boolean,
  },
};
</script>
